const BASE_INTERVAL_MS = 60000;
const JITTER_MS = 5000;
const MAX_INTERVAL_MS = 600000;

/**
 * Delay before the next notification poll, given how many polls have failed back-to-back.
 * Zero failures reproduces the steady-state cadence (60s plus a small random offset that keeps
 * many sessions from aligning into per-minute bursts). Each consecutive failure doubles the wait,
 * capped, so clients ease off a struggling backend during an incident instead of every session
 * retrying at full rate and adding to the load. One success resets the caller's counter to zero.
 * The random source is a parameter purely so the delay can be asserted deterministically.
 */
export const nextPollDelay = (consecutiveFailures = 0, random = Math.random) => {
    const backoff = Math.min(BASE_INTERVAL_MS * 2 ** consecutiveFailures, MAX_INTERVAL_MS);
    return backoff + Math.floor(random() * JITTER_MS);
};
